import React, { memo, useState, useEffect, useContext } from "react";
import { makeStyles } from "@material-ui/styles";
import i18next from "i18next";
import { Menu, MenuItem } from "@material-ui/core";
import avatar from "../../../common/icons/avatar1.png";
import { emoji } from "../../../common/emoji";
import { renderTime } from "../../../utils";
import MessageStatus from "./messageStatus";
import MsgThreadInfo from "./msgThreadInfo";
import { CopyToClipboard } from "react-copy-to-clipboard";
import Reaction from "../reaction";
import RenderReactions from "../reaction/renderReaction";
import { EaseChatContext } from "../index";
import threadIcon from "../../../common/images/thread.png";
var useStyles = makeStyles(function (theme) {
  return {
    pulldownListItem: {
      display: "flex",
      padding: "10px 0",
      listStyle: "none",
      marginBottom: "26px",
      position: "relative",
      flexDirection: function flexDirection(props) {
        return props.bySelf ? "row-reverse" : "row";
      },
      alignItems: "center"
    },
    userName: {
      padding: "0 10px 4px",
      color: "#8797A4",
      fontSize: "14px",
      display: function display(props) {
        return props.chatType !== "singleChat" && !props.bySelf ? "inline-block" : "none";
      },
      textAlign: function textAlign(props) {
        return props.bySelf ? "right" : "left";
      }
    },
    textBodyBox: {
      display: "flex",
      flexDirection: function flexDirection(props) {
        return props.bySelf ? "inherit" : "column";
      },
      maxWidth: "75%",
      alignItems: function alignItems(props) {
        return props.bySelf ? "inherit" : "unset";
      }
    },
    time: {
      position: "absolute",
      fontSize: "11px",
      height: "16px",
      color: "rgba(1, 1, 1, .2)",
      lineHeight: "16px",
      textAlign: "center",
      top: "-18px",
      width: "100%"
    },
    read: {
      fontSize: "10px",
      color: "rgba(0,0,0,.15)",
      margin: "3px"
    },
    avatarStyle: {
      height: "40px",
      width: "40px",
      borderRadius: "50%"
    },
    textBody: {
      margin: function margin(props) {
        return props.bySelf ? "0 10px 10px 0" : props.rnReactions ? "15px 0 10px 10px" : "0 0 10px 10px";
      },
      lineHeight: "22px",
      fontSize: "16px",
      background: function background(props) {
        return props.bySelf ? "linear-gradient(124deg, #c913df 20%,#154DFE 90%)" : "#F2F2F2";
      },
      color: function color(props) {
        return props.bySelf ? "#fff" : "#000";
      },
      borderRadius: function borderRadius(props) {
        return props.bySelf ? "16px 16px 4px 16px" : "16px 16px 16px 4px";
      },
      padding: "8px 12px",
      width: "100%",
      maxWidth: "100%",
      // maxWidth: "80%",
      // minWidth: "40%",
      wordBreak: "break-all",
      textAlign: "initial",
      position: "relative",
      boxSizing: "border-box"
    },
    textReaction: {
      position: "absolute",
      right: function right(props) {
        return props.bySelf ? "" : "0";
      },
      bottom: "-10px",
      transform: function transform(props) {
        return props.bySelf ? "translateX(-100%)" : "translateX(100%)";
      },
      marginLeft: function marginLeft(props) {
        return props.bySelf ? "-15px" : "";
      },
      height: '24px'
    },
    textReactionCon: {
      height: '100%',
      width: function width(props) {
        return props.showThreadEntry ? "48px" : "24px";
      },
      "float": function float(props) {
        return props.bySelf ? 'right' : 'left';
      }
    },
    reactionBox: {
      position: "absolute",
      top: function top(props) {
        return props.bySelf ? "-15px" : "-18px";
      },
      right: function right(props) {
        return props.bySelf ? "0px" : "";
      },
      left: function left(props) {
        return props.bySelf ? "" : "0px";
      },
      background: "#F2F2F2",
      borderRadius: "17.5px",
      padding: function padding(props) {
        return props.rnReactions ? "4px 8px" : "4px";
      },
      border: "solid 2px #FFFFFF",
      boxShadow: "0 10px 10px 0 rgb(0 0 0 / 30%)"
    },
    threadCon: {
      "float": function float(props) {
        return props.bySelf ? 'left' : 'right';
      },
      height: '24px',
      width: '24px',
      borderRadius: '50%',
      '&:hover': {
        background: '#E6E6E6'
      }
    },
    thread: {
      marginTop: '5px',
      marginLeft: '4px',
      width: '16px',
      height: '15px',
      background: "url(" + threadIcon + ") center center no-repeat",
      backgroundSize: 'contain',
      cursor: 'pointer'
    }
  };
});
var initialState = {
  mouseX: null,
  mouseY: null
};

function TextMessage(_ref) {
  var message = _ref.message,
      onRecallMessage = _ref.onRecallMessage,
      showByselfAvatar = _ref.showByselfAvatar,
      onCreateThread = _ref.onCreateThread,
      isThreadPanel = _ref.isThreadPanel,
      showThread = _ref.showThread;
  var easeChatProps = useContext(EaseChatContext);
  var onAvatarChange = easeChatProps.onAvatarChange,
      isShowReaction = easeChatProps.isShowReaction,
      customMessageClick = easeChatProps.customMessageClick,
      customMessageList = easeChatProps.customMessageList;

  var _useState = useState(false),
      hoverDeviceModule = _useState[0],
      setHoverDeviceModule = _useState[1];

  var reactionMsg = (message === null || message === void 0 ? void 0 : message.reactions) || [];
  var showThreadEntry = showThread && !message.chatThreadOverview && !isThreadPanel && message.chatType === 'groupChat';
  var showThreaddInfo = showThread && !isThreadPanel && message.chatType === "groupChat" && message.chatThreadOverview && JSON.stringify(message.chatThreadOverview) !== '{}';
  var classes = useStyles({
    bySelf: message.bySelf,
    chatType: message.chatType,
    rnReactions: reactionMsg.length > 0,
    showThreadEntry: showThreadEntry
  });

  var _useState2 = useState(initialState),
      menuState = _useState2[0],
      setMenuState = _useState2[1];

  var _useState3 = useState(''),
      copyMsgVal = _useState3[0],
      setCopyMsgVal = _useState3[1];

  useEffect(function () {
    setCopyMsgVal(message.msg);
  }, [copyMsgVal]);

  var handleClick = function handleClick(event) {
    event.preventDefault();
    setMenuState({
      mouseX: event.clientX - 2,
      mouseY: event.clientY - 4
    });
  };

  var handleClose = function handleClose() {
    setMenuState(initialState);
  };

  var recallMessage = function recallMessage() {
    onRecallMessage(message);
    handleClose();
  };

  var renderTxt = function renderTxt(txt) {
    if (txt === undefined) {
      return [];
    }

    var rnTxt = [];
    var match = null;
    var regex = /(\[.*?\])/g;
    var start = 0;
    var index = 0;

    while (match = regex.exec(txt)) {
      index = match.index;

      if (index > start) {
        rnTxt.push(txt.substring(start, index));
      }

      if (match[1] in emoji.map) {
        var v = emoji.map[match[1]];
        rnTxt.push( /*#__PURE__*/React.createElement("img", {
          key: v + Math.floor(Math.random() * 99 + 1),
          alt: v,
          src: require("../../../common/faces/" + v)["default"],
          width: 20,
          height: 20,
          style: {
            verticalAlign: 'middle'
          }
        }));
      } else {
        rnTxt.push(match[1]);
      }

      start = index + match[1].length;
    }

    rnTxt.push(txt.substring(start, txt.length));
    return rnTxt;
  };

  var sentStatus = function sentStatus() {
    return /*#__PURE__*/React.createElement("div", null, message.bySelf && isThreadPanel && message.status !== 'sent' && /*#__PURE__*/React.createElement(MessageStatus, {
      status: message.status,
      style: {
        marginRight: '-30px',
        marginTop: message.chatType === "singleChat" ? "0" : "22px"
      }
    }));
  };

  var createThread = function createThread() {
    onCreateThread(message);
  };

  var changeCopyVal = function changeCopyVal() {
    setCopyMsgVal(message.msg);
    handleClose();
  };

  var _customMessageClick = function _customMessageClick(val, option) {
    return function (e) {
      customMessageClick && customMessageClick(e, val, option);
      handleClose();
    };
  };

  return /*#__PURE__*/React.createElement("li", {
    className: classes.pulldownListItem,
    onMouseOver: function onMouseOver() {
      return setHoverDeviceModule(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHoverDeviceModule(false);
    }
  }, /*#__PURE__*/React.createElement("div", null, !message.bySelf && /*#__PURE__*/React.createElement("img", {
    className: classes.avatarStyle,
    src: avatar,
    onClick: function onClick(e) {
      return onAvatarChange && onAvatarChange(e, message);
    }
  }), showByselfAvatar && message.bySelf && /*#__PURE__*/React.createElement("img", {
    className: classes.avatarStyle,
    src: avatar
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.textBodyBox
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.userName
  }, message.from), /*#__PURE__*/React.createElement("div", {
    className: classes.textBody,
    onContextMenu: handleClick,
    id: message.id
  }, renderTxt(message.body.msg), message.isThread, showThreaddInfo ? /*#__PURE__*/React.createElement(MsgThreadInfo, {
    message: message
  }) : null, reactionMsg.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: classes.reactionBox
  }, /*#__PURE__*/React.createElement(RenderReactions, {
    message: message
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.textReaction
  }, hoverDeviceModule ? /*#__PURE__*/React.createElement("div", {
    className: classes.textReactionCon
  }, isShowReaction && /*#__PURE__*/React.createElement(Reaction, {
    message: message
  }), showThreadEntry && /*#__PURE__*/React.createElement("div", {
    className: classes.threadCon,
    onClick: createThread,
    title: "Reply"
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.thread
  }))) : sentStatus()))), /*#__PURE__*/React.createElement("div", {
    className: classes.time
  }, renderTime(message.time)), message.status === "read" ? /*#__PURE__*/React.createElement("div", {
    className: classes.read
  }, i18next.t("Read")) : null, /*#__PURE__*/React.createElement(Menu, {
    keepMounted: true,
    open: menuState.mouseY !== null,
    onClose: handleClose,
    anchorReference: "anchorPosition",
    anchorPosition: menuState.mouseY !== null && menuState.mouseX !== null ? {
      top: menuState.mouseY,
      left: menuState.mouseX
    } : undefined
  }, message.bySelf && /*#__PURE__*/React.createElement(MenuItem, {
    onClick: recallMessage
  }, i18next.t("withdraw")), /*#__PURE__*/React.createElement(MenuItem, {
    onClick: changeCopyVal
  }, /*#__PURE__*/React.createElement(CopyToClipboard, {
    text: copyMsgVal
  }, /*#__PURE__*/React.createElement("span", null, i18next.t("Copy")))), customMessageList && customMessageList.map(function (val, key) {
    var bySelf = message.bySelf;
    var show = false;

    if (val.position === 'others') {}

    switch (val.position) {
      case 'others':
        show = bySelf ? false : true;
        break;

      case 'self':
        show = bySelf ? true : false;
        break;

      default:
        show = true;
        break;
    }

    return show ? /*#__PURE__*/React.createElement(MenuItem, {
      key: key,
      onClick: _customMessageClick(val, message)
    }, val.name) : null;
  })));
}

export default memo(TextMessage);